module.exports = __webpack_public_path__ + "static/media/IMG_7578.a2947c5e.JPG";